export default __webpack_public_path__ + "static/media/lp-new-ganzkoerper-pricing-desktop.fc82fe2c.jpg";